import ApiService from "@emcd-shared/api-service";
import AnalyticsService from "@emcd-shared/analytics-service";
import { TWO_FA_CONTEXT_FLOW } from "../../../common/const";

class SmsService {
  static SMS_ENDPOINTS = {
    [TWO_FA_CONTEXT_FLOW.DEFAULT]: "/auth/resend-sms",
    [TWO_FA_CONTEXT_FLOW.REGISTRATION]: "/oauth/phone/resend_code",
    [TWO_FA_CONTEXT_FLOW.AUTH]: "/oauth/phone/resend_code"
  };

  static HTTP_METHODS = {
    [TWO_FA_CONTEXT_FLOW.DEFAULT]: 'get',
    [TWO_FA_CONTEXT_FLOW.AUTH]: 'post',
    [TWO_FA_CONTEXT_FLOW.REGISTRATION]: 'post',
  };

  static HEADER_NAME = {
    [TWO_FA_CONTEXT_FLOW.REGISTRATION]: '2fa-secret-key',
    [TWO_FA_CONTEXT_FLOW.AUTH]: '2fa-secret-key',
    [TWO_FA_CONTEXT_FLOW.DEFAULT]: 'secret-key',
  };


  static getBaseApiUrl() {
    return globalThis?.import_meta_env?.VUE_APP_ENDPOINT_API_URL ||
      process.env.VUE_APP_ENDPOINT_API_URL ||
      "https://endpoint.emcd.io";
  }

  static getSmsApiUrl(contextFlow) {
    const endpoint = this.SMS_ENDPOINTS[contextFlow] || this.SMS_ENDPOINTS[TWO_FA_CONTEXT_FLOW.DEFAULT];
    const baseUrl = this.getBaseApiUrl();

    try {
      const targetUrl = new URL(endpoint, baseUrl);
      return targetUrl.toString();
    } catch (error) {
      AnalyticsService.error(error);
      return endpoint;
    }
  }

  static createRequestConfig(method, headers) {
    const isGetMethod = method.toLowerCase() === 'get';
    return isGetMethod ? headers : { headers }
  }

  static async resendCode(secretKey, contextFlow) {
    if (!secretKey) {
      AnalyticsService.exception("missedSecretKey");
      throw new Error("Secret key is required");
    }

    try {
      const method = this.HTTP_METHODS[contextFlow] || this.HTTP_METHODS[TWO_FA_CONTEXT_FLOW.DEFAULT];
      const url = this.getSmsApiUrl(contextFlow);
      const headerName = this.HEADER_NAME[contextFlow] || this.HEADER_NAME[TWO_FA_CONTEXT_FLOW.DEFAULT]
      const headers = this.createRequestConfig(method, { [headerName]: secretKey });

      return await ApiService[method](url, undefined, headers);
    } catch (error) {
      AnalyticsService.error(error);
      throw error;
    }
  }
}

export const resendCode = SmsService.resendCode.bind(SmsService);
